import React from 'react';
import { SuccessPage } from "../../components/SuccessPage";
import styles from "./RelationshipSigned.module.scss";
import { Callout, Typography } from 'seagull';
import { ThankYouIcon } from "./ThankYouIcon";
import MissingSignaturesRecipients from "../../../components/MissingSignaturesRecipients/MissingSignaturesRecipients";
import { useCobConfig } from "../CobConfigContext";
const PendingAdditionalSignatures = () => {
  const {
    relationship
  } = useCobConfig();
  return /*#__PURE__*/React.createElement(SuccessPage, {
    "data-testid": "pending-additional-signatures-page",
    image: /*#__PURE__*/React.createElement(ThankYouIcon, null)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.successPageContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    weight: "bold",
    className: styles.header
  }, "Thanks for signing!"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    className: styles.pendingAdditionalSignatures
  }, "Pending additional signatures"), /*#__PURE__*/React.createElement(Callout, {
    intent: "info",
    className: styles.callout,
    hideIcon: true
  }, "A confirmation email will be sent once all signatures are collected."), /*#__PURE__*/React.createElement(Typography, {
    variant: 'h5',
    className: styles.awaitingRecipients
  }, "Awaiting the following recipients:"), /*#__PURE__*/React.createElement(MissingSignaturesRecipients, {
    relationship: relationship
  })));
};
export default PendingAdditionalSignatures;